module.exports = __webpack_public_path__ + "img/8.0ed16ce3.jpg";